import React from "react";
import clsx from "clsx";

interface Props {
  children: React.ReactNode;
  className?: string;
}

const AuthCard = ({ children, className }: Props) => (
  <div className={clsx("rounded-2xl bg-white w-full shadow-md", className)}>{children}</div>
);

export default AuthCard;
